import { Component, Input, OnInit, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from '@hakimio/ngx-google-analytics';
import { GoogleAnalyticsCategory, GoogleAnalyticsEvents } from '@app/@models/constants';

// this match the css class defined in 'modal-youtube-video.component.scss'
export const MODAL_YOUTUBE_CSS_CLASS: string = 'modal-youtube' as const;

@Component({
  selector: 'pl-modal-youtube-video',
  templateUrl: './modal-youtube-video.component.html',
  styleUrls: ['./modal-youtube-video.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalYoutubeVideoComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private gaService: GoogleAnalyticsService = inject(GoogleAnalyticsService);

  @Input({ required: true }) public videoUrl!: string;

  public close(): void {
    this.activeModal.dismiss();
  }

  public ngOnInit(): void {
    this.gaService.event(GoogleAnalyticsEvents.openYoutubeTedTalk, {
      category: GoogleAnalyticsCategory.userNavigation,
      label: 'play',
    });
  }
}
